// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PopoverHeaderCloseButton-base__neg51{margin-left:var(--size-5)}.PopoverHeaderCloseButton-iconButton__vQTjo{flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "PopoverHeaderCloseButton-base__neg51",
	"iconButton": "PopoverHeaderCloseButton-iconButton__vQTjo"
};
export default ___CSS_LOADER_EXPORT___;
